module.exports = __webpack_public_path__ + "img/收支明细.3e03fee3.png";